<template>
    <div>
        <v-date-picker 
            mode='multiple' 
            v-model='selectedValues' 
            :attributes="attrs" 
            :available-dates='{ start: (!!dates && dates.length > 0) ? new Date(dates[0]) : minDate, end: (!!dates && dates.length > 0) ? new Date(dates[dates.length - 1]) : null }'
            :popoverDirection="popoverDirection">
        </v-date-picker>
    </div>
</template>

<script>
import { setupCalendar, DatePicker } from 'v-calendar'

setupCalendar({
  firstDayOfWeek: 2,
  datePickerTintColor: '#001e3b',
  popoverKeepVisibleOnInput: true,
  locale: 'nl-NL',
    formats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['DD-MM-YYYY', 'DD/MM/YYYY', 'L'],
        dayPopover: 'DD-MM-YYYY',
    }
});

export default {
    name: 'multi-date-picker',
    props: {
        dates: {
            type: Array
        }, 
        popoverDirection: {
            type: String,
            default: "bottom"
        },
    },
    components: {
        'v-date-picker': DatePicker
    },
    data() {
        return {
            selectedValues: [],
            attrs: [
                {
                key: 'today',
                highlight: {
                    backgroundColor: '#d8ebff',
                    // Other properties are available too, like `height` & `borderRadius`
                },
                dates: new Date(2019, 0, 1)
                }
            ],
        };
    },
    mounted() {
        if(this.dates)
        {
            this.selectedValues = this.dates.map((d) => { return new Date(d); });
        }
        if(this.popoverDirection) {
            //debugger
        }
    },
    computed: {
        minDate() {
            let date = new Date();
            return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
        }
    },
    watch: {
        selectedValues(to, from) {
            if(to == null)
                to = [];
                
            return this.$emit('update', to);
        },
    }
};
</script>

<style lang="scss" scoped>
@import '~v-calendar/lib/v-calendar.min.css';

/deep/ {
    input {
        width: 100%;
        color: $darkColor;
        height: calc(2.25rem + 2px);
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        border: none;
        border-radius: 0.25rem;
        border-bottom: 1px solid $darkColor;
        background-color: transparent;
        min-width: 100px !important;
    }
}
</style>